import { observer } from 'mobx-react-lite';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useStore } from '@shared/hooks/useStore';
import { ROUTES } from '@shared/configs/constants';

export const AuthGuard = observer(() => {
    const { authStore } = useStore();
    const location = useLocation();

    // Still loading profile
    if (authStore.token && !authStore.profile) {
        return (
            <div className='flex items-center justify-center h-screen'>
                <div className='animate-spin rounded-full h-12 w-12 border-b-2 border-primary'></div>
            </div>
        );
    }

    // Not logged in
    if (!authStore.isLoggedIn) {
        return <Navigate to={ROUTES.home.href} state={{ from: location }} replace />;
    }

    return <Outlet />;
});
